import { Route, Switch } from 'react-router-dom';

import { UsersListPage } from 'features/users/pages/UsersListPage';
import { usersPaths } from 'features/users/routes/paths';
import { Title } from 'shared';
import { useTranslation } from 'hooks/useTranslation';

export const UsersRouter = () => {
  const { t } = useTranslation('app');

  return (
    <>
      <Title title={t('users')} />
      <Switch>
        <Route path={usersPaths.static.root} component={UsersListPage} />
      </Switch>
    </>
  );
};
